/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ marginLeft: _vm.widgets.content.margin + 'px', marginRight: _vm.widgets.content.margin + 'px' })},[_c('div',{staticClass:"w-full border h-px",class:[_vm.widgets.content.type],style:({
            borderColor: _vm.widgets.content.color,
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }